import React, { useState } from "react";
import styles from "./RsvpGuestWishing.module.css";
import { Col, Layout, Row } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import bgcImage1 from "../../../../assets/bgcimage1.png";
import Rsvp from "../../../../assets/rsvp1.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { InputField, TextareaField } from "../../../../components";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import Image1 from "../../../../assets/vendorimg6.png";
import Image2 from "../../../../assets/vendorimg7.png";
import Image3 from "../../../../assets/vendorimg6.png";
import Image4 from "../../../../assets/vendorimg7.png";
import { useLocation, useNavigate } from "react-router-dom";
import { GuestMiddleware } from "../../../../Store/Middlewares/GuestMiddleware";
import { useDispatch, useSelector } from "react-redux";

const RsvpGuestWishing = () => {
  const navigate = useNavigate();
  const [note, setNote] = useState();

  const dispatch = useDispatch();
  const myStyle = {
    backgroundImage: `url(${bgcImage})`,
    backgroundRepeat: "no-repeat",
  };
  const myStyle1 = {
    backgroundImage: `url(${bgcImage1})`,
    backgroundRepeat: "no-repeat",
  };
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  const { state } = useLocation();

  console.log(state);

  const Rsvpdispatch = () => {
    let rsvpdata = {
      event_id: rsvpData?.event?.id,
      table_id: rsvpData?.table_id,
      answerByGuest: state.answerByGuest,
      selectedMeals: state.selectedMeal,
      Note: note,
      invitation_request:
        state.option == "Joyfully Accept" ? "confirmed" : "not attending",
    };
    dispatch(GuestMiddleware.submitRsvp(rsvpdata)).then(() => {
      navigate("/");
    });
    // .catch((err) => console.log(err));
  };
  return (
    <div style={myStyle} className={styles.mainContainer}>
      <Header
        mainHeader={styles.headerColor}
        isProfile={true}
        title={"RSVP"}
        style={{ padding: 0, background: "var(--white-color)", height: 85 }}
        onBackClick={() => navigate(-1)}
      />

      <div style={myStyle1} className={styles.mainDiv}>
        <TextComponent text={"Well Wishing"} textClass={styles.text} />
        <div className={styles.col}>
          <div className={styles.middlecontainer}>
            <TextComponent
              text={"Please Add A Well Wishing Note"}
              textClass={styles.text2}
            />
          </div>

          {/* <div className={styles.main_input}> */}
          <TextareaField
            className={styles.textArea}
            placeholder="Enter Your Message Here"
            rows={10}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          {/* <textarea
              className={styles.textArea}
              placeholder="Enter Your Message Here"
            /> */}
          {/* </div> */}
        </div>
        <Row className={styles.btnRow}>
          <Col xs={17} sm={12} lg={8}>
            <SubmitBotton
              btnClass={styles.btnClass}
              title={"Submit"}
              onClick={() => Rsvpdispatch()}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default RsvpGuestWishing;
